module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.students) ? _c('section', {
    staticClass: "sessions-scheduler"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._v("\n        " + _vm._s(_vm.meetingType) + "\n        "), _c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": function($event) {
        _vm.$parent.showScheduler = false
      }
    }
  }), _vm._v(" "), _c('form', [_c('h3', [_vm._v("Schedule Your Student's Mentor Meetings")]), _vm._v(" "), (!_vm.valid) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Please add either only online or only on-campus students to the meeting.")]) : _vm._e(), _vm._v(" "), (_vm.type === 'campus') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Location")]), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.locations), function(location) {
    return _c('option', {
      domProps: {
        "value": location.id
      }
    }, [_vm._v(_vm._s(location.name))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('date-picker', {
    attrs: {
      "date": _vm.date,
      "option": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Number of occurances")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeat),
      expression: "repeat"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.repeat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((14), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }))]), _vm._v(" "), (_vm.students) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeStudents),
      expression: "includeStudents"
    }],
    staticClass: "form-control students",
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.includeStudents = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.students), function(student) {
    return _c('option', {
      staticClass: "student",
      domProps: {
        "value": student.id
      }
    }, [_vm._v("\n                        " + _vm._s(student.firstName) + " " + _vm._s(student.lastName) + "\n                    ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.date.time !== '') ? _c('p', {
    staticClass: "schedule"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v(_vm._s(_vm.repeat) + " Meeting"), (_vm.repeat > 1) ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v("\n                will be scheduled starting on\n                "), _c('span', {
    staticClass: "underline"
  }, [_vm._v(_vm._s(_vm._f("longDate")(_vm.date.time)))]), _vm._v(" "), (_vm.repeat > 1) ? _c('span', [_vm._v("\n                    and ending on\n                    "), _c('span', {
    staticClass: "underline"
  }, [_vm._v(_vm._s(_vm._f("longDate")(_vm.endTime)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.type === 'online') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addSessions()
      }
    }
  }, [_vm._v("Schedule Sessions")]) : _vm._e(), _vm._v(" "), (_vm.type === 'campus') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addCampusMeetings()
      }
    }
  }, [_vm._v("Schedule Meetings")]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6837aea0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/MentorSessionScheduler.vue
// module id = 2036
// module chunks = 2